import Button from '@rio-cloud/rio-uikit/Button';
import type { AssetType } from '@rio-cloud/rio-uikit/components/assetTree/TreeSummary';
import { FormattedMessage } from 'react-intl';

import type { RentalAssetData } from '../../../../domain/model/rental-asset.types';
import { RENTAL_TYPE } from '../../../../domain/model/rentals.types';
import StartRentalDialogBody from '../../../dialogs/StartRentalDialogBody';
import ScreenshotDialog from './ScreenshotDialog';

export const StartRentalDialogScreenshot = () => {
    const selectedRental: RentalAssetData[] = [
        {
            asset: {
                assetId: 'asset-123',
                vehicleName: 'Vehicle 123',
                type: 'Truck' as AssetType,
                status: 'active',
                licensePlate: 'ABC123',
                licensePlateCountryCode: 'DE',
                vin: '1111B5GB0BA714579',
            },
            rental: null,
            renterAccountDisplayName: 'ACME Corp',
            hasRentalPartnershipWithRenter: true,
            devices: [],
        },
    ];
    return (
        <ScreenshotDialog
            title={<FormattedMessage id='intl-msg:rental-web.dialog.start-rental.title' />}
            buttons={
                <Button bsStyle='primary' onClick={() => {}} disabled={false} iconName='rioglyph-ok-dashed'>
                    <FormattedMessage id='intl-msg:rental-web.dialog.start-rental.button.title' />
                </Button>
            }
        >
            <StartRentalDialogBody
                selectedRentalAssetData={selectedRental}
                renterPartnerCompanies={[]}
                setSelectedAccountId={() => {}}
                setRenterIdentifier={() => {}}
                selectedOption={RENTAL_TYPE.EXTERNAL}
                setSelectedOption={() => {}}
            />
        </ScreenshotDialog>
    );
};
